export default "__VITE_ASSET__d925826c__"